import { languages } from '../../configs/language'

export const STEP = {
  SHOPPING_CART: 1,
  ORDER_INFORMATION: 2,
  ORDER_CONFIRMATION: 3,
}

export const LANGUAGE = {
  EN: languages.en,
  VI: languages.vi,
}

export const LANGUAGE_SELECT = [
  {
    label: 'cartAndOrders.main.VIETNAMESE',
    value: languages.vi,
    isI18n: true,
  },
  {
    label: 'cartAndOrders.main.ENGLISH',
    value: languages.en,
    isI18n: true,
  },
]

export const PAYMENT_METHOD = {
  PACKAGE: 'PACKAGE',
  BANK_TRANSFERS: 'BANK_TRANSFERS',
  CARD: 'CARD',
  POST_PAID: 'POST_PAID',
}
export const PAYMENT_METHOD_CODE = {
  [PAYMENT_METHOD.PACKAGE]: 'Package',
  [PAYMENT_METHOD.BANK_TRANSFERS]: 'BankTransfers',
  [PAYMENT_METHOD.CARD]: 'Card',
  [PAYMENT_METHOD.POST_PAID]: 'PostPaid',
}

export const BANK_TRANSFER_TYPE = {
  ONE_PAY_ONLINE: 'OnePayOnline',
}

export const TYPE_TRANSFER = {
  VND: 'VND',
  USD: 'USD',
}

export const CODE_BANK_TRANSFER = {
  [BANK_TRANSFER_TYPE.INTERNATIONAL]: 2,
  [BANK_TRANSFER_TYPE.DOMESTIC]: 1,
  [BANK_TRANSFER_TYPE.PAYPAL]: 0,
  [BANK_TRANSFER_TYPE.ONE_PAY_ONLINE]: 3,
}

export const REPORT_TYPE = {
  FIINGATE_FACTSHEET: 'FiinGate Factsheet',
  BUSINESS_CREDIT: 'Business Credit Report',
}

export const STYLE_DISABLE = {
  pointerEvents: 'none',
  opacity: 0.6,
}

export const IDS_REPORT = {
  SCREENING: 1,
  FIINGATE_FACTSHEET: 2,
  CREDIT_BUSINESS: 3,
  STANDARD_BUSINESS: 4,
  COMPREHENSIVE_BUSINESS: 5,
}

export const BUSINESS_REPORT_TYPE_SELECT = [
  {
    label: 'Standard Business Report',
    value: 4,
  },
  {
    label: 'Comprehensive Business Report',
    value: 5,
  },
  {
    label: 'Credit Business Report',
    value: 3,
  },
]

export const VERSION_REPORT = {
  REQUEST: 'cartAndOrders.cart.onRequest',
  READY: 'cartAndOrders.cart.readyVersion',
}

export const VERSION_TYPE_SELECT = [
  {
    label: VERSION_REPORT.REQUEST,
    value: false,
    isI18n: true,
  },
  {
    label: VERSION_REPORT.READY,
    value: true,
    isI18n: true,
  },
]

export const DELIVERY_TIME = {
  [IDS_REPORT.CREDIT_BUSINESS]: 'cartAndOrders.cart.timeCredit',
  [IDS_REPORT.STANDARD_BUSINESS]: 'cartAndOrders.cart.timeStandard',
  [IDS_REPORT.COMPREHENSIVE_BUSINESS]: 'cartAndOrders.cart.timeComprehensive',
}

export const PAYMENT = {
  PAYPAL: {
    code: 0,
    name: 'Paypal',
    value: 'Paypal',
  },
  NAPAS_DOMESTIC: {
    code: 1,
    name: 'Napas Domestic',
    value: 'NapasDomestic',
  },
  NAPAS_NATIONAL: {
    code: 2,
    name: 'Napas National',
    value: 'NapasNational',
  },
  PAY_ONLINE: {
    code: 3,
    name: 'OnePayOnline',
    value: 'OnePayOnline',
  },
  PAY_TRANSFER: {
    code: 4,
    name: 'OnePayTransfer',
    value: 'OnePayTransfer',
  },
}

export const CHECKBOX_TRADE_DISCOUNT = {
  DISCOUNT: 'discount',
  VOUCHER: 'voucher',
}

export const TYPE_STATUS_ORDER = {
  PAID: 'TransactionSuccess',
  UNPAID: 'TransactionInvalid',
  CHECKING: 'Checking',
  PENDING: 'TransactionPending',
}

export const MIN_HEIGHT_CHECK_OUT = 70
